// Copyright ©️ 2026 eVolve MEP, LLC

import { type DateOnly, today, type ISOTimestamp } from '@evolvemep/api-ts';
import { parseISO, isValid, differenceInDays } from 'date-fns';

import type { CustomStatus } from 'components/Mantine/StatusEditor/types';
import type { EntityStateAgGridContext } from 'helpers/ag-grid/EntitySetFilterComponent';
import { isNotNil, isNil } from 'helpers/isNotNil';

export type WorkOrdersPageAgContext = EntityStateAgGridContext<'Work Order'> & {
  statuses: CustomStatus<'Work Order'>[];
};

export const getDaysEarlyLate = (
  needBy: DateOnly | null | undefined,
  productionCompletedOn: ISOTimestamp | undefined,
) => {
  const firstDate = isNotNil(needBy) ? parseISO(needBy) : null;
  const statusDate = isNotNil(productionCompletedOn) ? parseISO(productionCompletedOn) : null;
  if (isNil(firstDate) || isNil(statusDate) || !isValid(statusDate)) return 0;
  return differenceInDays(firstDate, statusDate);
};

export const getDaysRemaining = (needBy: DateOnly | null | undefined) => {
  const firstDate = isNotNil(needBy) ? parseISO(needBy) : null;
  if (isNil(firstDate) || !isValid(firstDate)) return 0;
  return differenceInDays(firstDate, parseISO(today()));
};

export const getDaysRemainingOrDaysEarlyLate = (
  needBy: DateOnly | null | undefined,
  productionCompletedOn?: ISOTimestamp,
) => (isNil(productionCompletedOn) ? getDaysRemaining(needBy) : getDaysEarlyLate(needBy, productionCompletedOn));
